/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContactDto } from '../models';
// @ts-ignore
import type { CustomerItemDto } from '../models';
// @ts-ignore
import type { UpdateProcessContactsRequestDto } from '../models';
/**
 * RestProcessesCustomerApi - axios parameter creator
 */
export const RestProcessesCustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Updating process customer by its id contact id - (contact id has relation to customer), one of customerId or contactId is required
         * @param {string} processId 
         * @param {number} [customerId] 
         * @param {number} [contactId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerToProcess: async (processId: string, customerId?: number, contactId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addCustomerToProcess', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/customers`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (contactId !== undefined) {
                localVarQueryParameter['contactId'] = contactId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessContacts: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessContacts', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/contacts`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCustomer: async (processId: string, customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessCustomer', 'processId', processId)
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getProcessCustomer', 'customerId', customerId)
            const localVarPath = `/api/processes/{processId}/customers`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessContactsRequestDto} updateProcessContactsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessContacts: async (processId: string, updateProcessContactsRequestDto: UpdateProcessContactsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessContacts', 'processId', processId)
            // verify required parameter 'updateProcessContactsRequestDto' is not null or undefined
            assertParamExists('updateProcessContacts', 'updateProcessContactsRequestDto', updateProcessContactsRequestDto)
            const localVarPath = `/api/processes/{processId}/contacts`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessContactsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessesCustomerApi - functional programming interface
 */
export const RestProcessesCustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessesCustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * Updating process customer by its id contact id - (contact id has relation to customer), one of customerId or contactId is required
         * @param {string} processId 
         * @param {number} [customerId] 
         * @param {number} [contactId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCustomerToProcess(processId: string, customerId?: number, contactId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCustomerToProcess(processId, customerId, contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesCustomerApi.addCustomerToProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessContacts(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContactDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessContacts(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesCustomerApi.getProcessContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCustomer(processId: string, customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCustomer(processId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesCustomerApi.getProcessCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessContactsRequestDto} updateProcessContactsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessContacts(processId: string, updateProcessContactsRequestDto: UpdateProcessContactsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessContacts(processId, updateProcessContactsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesCustomerApi.updateProcessContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessesCustomerApi - factory interface
 */
export const RestProcessesCustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessesCustomerApiFp(configuration)
    return {
        /**
         * Updating process customer by its id contact id - (contact id has relation to customer), one of customerId or contactId is required
         * @param {string} processId 
         * @param {number} [customerId] 
         * @param {number} [contactId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCustomerToProcess(processId: string, customerId?: number, contactId?: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCustomerToProcess(processId, customerId, contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessContacts(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContactDto>> {
            return localVarFp.getProcessContacts(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCustomer(processId: string, customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerItemDto> {
            return localVarFp.getProcessCustomer(processId, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessContactsRequestDto} updateProcessContactsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessContacts(processId: string, updateProcessContactsRequestDto: UpdateProcessContactsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessContacts(processId, updateProcessContactsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessesCustomerApi - interface
 */
export interface RestProcessesCustomerApiInterface {
    /**
     * Updating process customer by its id contact id - (contact id has relation to customer), one of customerId or contactId is required
     * @param {string} processId 
     * @param {number} [customerId] 
     * @param {number} [contactId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addCustomerToProcess(processId: string, customerId?: number, contactId?: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessContacts(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContactDto>>;

    /**
     * 
     * @param {string} processId 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCustomer(processId: string, customerId: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerItemDto>;

    /**
     * 
     * @param {string} processId 
     * @param {UpdateProcessContactsRequestDto} updateProcessContactsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessContacts(processId: string, updateProcessContactsRequestDto: UpdateProcessContactsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessesCustomerApi - object-oriented interface
 */
export class RestProcessesCustomerApi extends BaseAPI implements RestProcessesCustomerApiInterface {
    /**
     * Updating process customer by its id contact id - (contact id has relation to customer), one of customerId or contactId is required
     * @param {string} processId 
     * @param {number} [customerId] 
     * @param {number} [contactId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addCustomerToProcess(processId: string, customerId?: number, contactId?: number, options?: RawAxiosRequestConfig) {
        return RestProcessesCustomerApiFp(this.configuration).addCustomerToProcess(processId, customerId, contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessContacts(processId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesCustomerApiFp(this.configuration).getProcessContacts(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {number} customerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCustomer(processId: string, customerId: number, options?: RawAxiosRequestConfig) {
        return RestProcessesCustomerApiFp(this.configuration).getProcessCustomer(processId, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {UpdateProcessContactsRequestDto} updateProcessContactsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessContacts(processId: string, updateProcessContactsRequestDto: UpdateProcessContactsRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesCustomerApiFp(this.configuration).updateProcessContacts(processId, updateProcessContactsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

